<template>
  <div class="view-container">
    <div class="search-panel">
      <div class="search-row-single">
        <div class="search-item"><label>文档名称</label><input v-model="searchForm.docName" class="form-control" placeholder="搜索文档"></div>
        <div class="search-item"><label>审批状态</label><select v-model="searchForm.status" class="form-control"><option value="">全部</option><option value="pending">待审批</option><option value="approved">已通过</option><option value="rejected">已驳回</option></select></div>
        <div class="search-item"><label>提交人</label><input v-model="searchForm.submitter" class="form-control" placeholder="提交人"></div>
        <div class="search-actions">
          <button @click="handleSearch" class="btn btn-primary"><i class="fas fa-search"></i> 查询</button>
          <button @click="resetSearch" class="btn btn-default"><i class="fas fa-undo"></i> 重置</button>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="table-container">
        <table class="data-table">
          <thead><tr>
            <th width="50">ID</th><th>文档名称</th><th>文档编号</th><th width="60">版本</th><th width="70">类型</th><th width="70">提交人</th>
            <th width="120">提交时间</th><th width="80">审批状态</th><th width="100">审批人</th><th width="140">操作</th>
          </tr></thead>
          <tbody>
            <tr v-for="d in filteredData" :key="d.id">
              <td>{{ d.id }}</td><td><i class="fas fa-file-alt"></i> {{ d.docName }}</td><td>{{ d.docCode }}</td>
              <td><span class="version-tag">v{{ d.version }}</span></td>
              <td>{{ d.docType.toUpperCase() }}</td><td>{{ d.submitter }}</td>
              <td class="time-cell">{{ d.submitTime }}</td>
              <td><span class="status-badge" :class="d.status">{{ statusLabels[d.status] }}</span></td>
              <td>{{ d.reviewer || '-' }}</td>
              <td class="action-cell">
                <button @click="viewDetail(d)" class="btn btn-info btn-xs"><i class="fas fa-eye"></i> 查看</button>
                <button v-if="d.status==='pending'" @click="doApprove(d)" class="btn btn-success btn-xs"><i class="fas fa-check"></i> 通过</button>
                <button v-if="d.status==='pending'" @click="doReject(d)" class="btn btn-danger btn-xs"><i class="fas fa-times"></i> 驳回</button>
              </td>
            </tr>
            <tr v-if="filteredData.length===0"><td colspan="10" class="empty-cell">暂无审批数据</td></tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-row">
        <div class="pagination-info">共 {{ totalCount }} 条记录</div>
        <div class="pagination-controls">
          <div class="page-size-selector"><span>每页</span><select v-model="pageSize" class="page-size-input form-control"><option :value="10">10</option><option :value="20">20</option><option :value="50">50</option></select><span>条</span></div>
          <button @click="prevPage" :disabled="currentPage===1" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-left"></i></button>
          <div class="page-numbers"><button v-for="p in visiblePages" :key="p" @click="goToPage(p)" :class="['page-btn',{active:currentPage===p,disabled:p==='...'}]" :disabled="p==='...'">{{ p }}</button></div>
          <button @click="nextPage" :disabled="currentPage>=totalPages" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-right"></i></button>
        </div>
      </div>
    </div>

    <div v-if="showDetailModal" class="modal-overlay" @click.self="showDetailModal=false">
      <div class="modal-dialog" style="width:750px">
        <div class="modal-header"><h4>文档审批详情</h4><button @click="showDetailModal=false" class="modal-close">&times;</button></div>
        <div class="modal-body" v-if="detailDoc">
          <div class="detail-grid">
            <div class="detail-item"><label>文档名称</label><span>{{ detailDoc.docName }}</span></div>
            <div class="detail-item"><label>文档编号</label><span>{{ detailDoc.docCode }}</span></div>
            <div class="detail-item"><label>版本</label><span>v{{ detailDoc.version }}</span></div>
            <div class="detail-item"><label>类型</label><span>{{ detailDoc.docType.toUpperCase() }}</span></div>
            <div class="detail-item"><label>提交人</label><span>{{ detailDoc.submitter }}</span></div>
            <div class="detail-item"><label>提交时间</label><span>{{ detailDoc.submitTime }}</span></div>
            <div class="detail-item" style="grid-column:1/-1"><label>变更说明</label><span>{{ detailDoc.changeDesc }}</span></div>
          </div>
          <div class="approval-history">
            <h5>审批记录</h5>
            <div class="approval-step" v-for="(step, idx) in detailDoc.approvalSteps" :key="idx">
              <div class="step-icon" :class="step.result"><i class="fas" :class="step.result==='approved'?'fa-check':step.result==='rejected'?'fa-times':'fa-clock'"></i></div>
              <div class="step-info"><span class="step-name">{{ step.name }}</span><span class="step-time">{{ step.time }}</span></div>
              <span class="step-comment" v-if="step.comment">{{ step.comment }}</span>
            </div>
          </div>
          <div v-if="detailDoc.status === 'pending'" class="approval-actions">
            <h5>审批操作</h5>
            <div class="form-group"><label>审批意见</label><textarea v-model="approvalComment" class="form-control" rows="3" placeholder="请输入审批意见..."></textarea></div>
            <div class="action-btns">
              <button @click="submitApprove(detailDoc, true)" class="btn btn-success"><i class="fas fa-check"></i> 审批通过</button>
              <button @click="submitApprove(detailDoc, false)" class="btn btn-danger"><i class="fas fa-times"></i> 驳回</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'

const statusLabels = { pending: '待审批', approved: '已通过', rejected: '已驳回' }
const currentPage = ref(1); const pageSize = ref(10)
const showDetailModal = ref(false); const detailDoc = ref(null); const approvalComment = ref('')

const searchForm = reactive({ docName: '', status: '', submitter: '' })

const auditList = ref([
  { id: 1, docName: '质量方针 QM-001-01', docCode: 'QM-001-01', version: '2.0', docType: 'doc', submitter: '张三', submitTime: '2026-06-10 14:30', status: 'pending', reviewer: null, changeDesc: '更新质量方针中关于客户满意的表述，增加持续改进的承诺', approvalSteps: [{ name: '提交', time: '2026-06-10 14:30', result: 'submitted' },{ name: '部门审批', time: '', result: 'pending' }] },
  { id: 2, docName: '采购控制程序_V3', docCode: 'QP-004', version: '3.0', docType: 'doc', submitter: '李四', submitTime: '2026-06-09 10:15', status: 'approved', reviewer: '王五', changeDesc: '全面修订采购流程，增加电子招标流程', approvalSteps: [{ name: '提交', time: '2026-06-09 10:15', result: 'submitted' },{ name: '部门审批', time: '2026-06-09 16:00', result: 'approved', comment: '同意修订' },{ name: '质量部审批', time: '2026-06-10 09:00', result: 'approved', comment: '符合质量体系要求' }] },
  { id: 3, docName: '供应商评估检查表', docCode: 'QR-001', version: '1.2', docType: 'xls', submitter: '赵六', submitTime: '2026-06-08 09:00', status: 'rejected', reviewer: '孙七', changeDesc: '新增供应商环境评估检查项', approvalSteps: [{ name: '提交', time: '2026-06-08 09:00', result: 'submitted' },{ name: '部门审批', time: '2026-06-08 14:00', result: 'rejected', comment: '检查项不完整，需要补充安全审查内容' }] },
  { id: 4, docName: '管理评审程序', docCode: 'QP-006', version: '1.0', docType: 'doc', submitter: '钱八', submitTime: '2026-06-07 11:00', status: 'pending', reviewer: null, changeDesc: '新编文件：规定管理评审的输入、输出和实施要求', approvalSteps: [{ name: '提交', time: '2026-06-07 11:00', result: 'submitted' },{ name: '部门审批', time: '', result: 'pending' }] },
  { id: 5, docName: '内部审核报告模板', docCode: 'QR-012', version: '2.1', docType: 'doc', submitter: '周九', submitTime: '2026-06-05 15:30', status: 'approved', reviewer: '张三', changeDesc: '优化报告格式，增加不符合项分类统计', approvalSteps: [{ name: '提交', time: '2026-06-05 15:30', result: 'submitted' },{ name: '部门审批', time: '2026-06-06 10:00', result: 'approved' }] }
])

const filteredData = computed(() => {
  let r = [...auditList.value]
  if (searchForm.docName) r = r.filter(d => d.docName.includes(searchForm.docName))
  if (searchForm.status) r = r.filter(d => d.status === searchForm.status)
  if (searchForm.submitter) r = r.filter(d => d.submitter.includes(searchForm.submitter))
  return r
})
const totalCount = computed(() => filteredData.value.length)
const totalPages = computed(() => Math.ceil(totalCount.value / pageSize.value) || 1)
const paginatedData = computed(() => { const s = (currentPage.value - 1) * pageSize.value; return filteredData.value.slice(s, s + pageSize.value) })
const visiblePages = computed(() => { const ps = [], t = totalPages.value, c = currentPage.value; if (t <= 7) { for (let i = 1; i <= t; i++) ps.push(i) } else { ps.push(1); if (c > 4) ps.push('...'); for (let i = Math.max(2, c - 2); i <= Math.min(t - 1, c + 2); i++) ps.push(i); if (c < t - 3) ps.push('...'); ps.push(t) } return ps })

const handleSearch = () => { currentPage.value = 1 }
const resetSearch = () => { Object.keys(searchForm).forEach(k => searchForm[k] = ''); currentPage.value = 1 }
const prevPage = () => { if (currentPage.value > 1) currentPage.value-- }
const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++ }
const goToPage = (p) => { if (typeof p === 'number' && p >= 1 && p <= totalPages.value) currentPage.value = p }

const viewDetail = (d) => { detailDoc.value = d; approvalComment.value = ''; showDetailModal.value = true }
const doApprove = (d) => { detailDoc.value = d; approvalComment.value = ''; showDetailModal.value = true }
const doReject = (d) => { detailDoc.value = d; approvalComment.value = ''; showDetailModal.value = true }
const submitApprove = (doc, approved) => {
  if (approved) { doc.status = 'approved'; doc.reviewer = '当前用户' }
  else { doc.status = 'rejected'; doc.reviewer = '当前用户' }
  const pendingStep = doc.approvalSteps.find(s => s.result === 'pending')
  if (pendingStep) { pendingStep.result = approved ? 'approved' : 'rejected'; pendingStep.time = new Date().toISOString().slice(0,16).replace('T',' '); pendingStep.comment = approvalComment.value || (approved ? '同意' : '驳回') }
  showDetailModal.value = false
  window.$message.success(approved ? '已审批通过' : '已驳回')
}
</script>

<style scoped>
.view-container { padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); display: flex; flex-direction: column; max-height: calc(100vh - 110px); overflow: hidden; }
.search-panel { background: #f9f9f9; border: 1px solid #e7eaec; border-radius: 4px; padding: 15px; margin-bottom: 15px; flex-shrink: 0; }
.search-row-single { display: flex; gap: 12px; align-items: center; }
.search-item { display: flex; align-items: center; gap: 8px; }
.search-item label { font-size: 13px; color: #676a6c; font-weight: 500; white-space: nowrap; }
.search-item .form-control { padding: 6px 10px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; width: 180px; }
.search-actions { display: flex; gap: 10px; margin-left: auto; }
.table-wrapper { border: 1px solid #e7eaec; border-radius: 4px; overflow: hidden; display: flex; flex-direction: column; flex: 1; min-height: 0; }
.table-container { overflow-y: auto; flex: 1; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 10px 12px; border-bottom: 1px solid #e7eaec; font-size: 13px; color: #676a6c; text-align: left; white-space: nowrap; }
.data-table th { background: #f5f5f5; font-weight: 600; position: sticky; top: 0; z-index: 2; }
.data-table tbody tr:hover { background: #f9fafb; }
.time-cell { color: #999; font-size: 12px; }
.empty-cell { text-align: center; padding: 40px; color: #999; }
.action-cell .btn-xs { margin: 0 2px; padding: 4px 8px; font-size: 11px; border-radius: 4px; cursor: pointer; border: 1px solid transparent; }
.btn-info.btn-xs { background: #3498db; color: #fff; }
.btn-success.btn-xs { background: #27ae60; color: #fff; }
.btn-danger.btn-xs { background: #e74c3c; color: #fff; }
.version-tag { background: #ede9fe; color: #7c3aed; padding: 1px 6px; border-radius: 3px; font-size: 11px; }
.status-badge { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 11px; font-weight: 500; }
.status-badge.pending { background: #fef3c7; color: #d97706; }
.status-badge.approved { background: #dcfce7; color: #16a34a; }
.status-badge.rejected { background: #fee2e2; color: #dc2626; }
.pagination-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 15px; background: #f9f9f9; border-top: 1px solid #e7eaec; flex-shrink: 0; }
.pagination-info { font-size: 13px; color: #676a6c; }
.pagination-controls { display: flex; align-items: center; gap: 10px; }
.page-numbers { display: flex; gap: 5px; }
.page-btn { width: 32px; height: 32px; border: 1px solid #e7eaec; background: #fff; color: #676a6c; border-radius: 4px; cursor: pointer; font-size: 13px; display: flex; align-items: center; justify-content: center; }
.page-btn:hover:not(.disabled) { border-color: #3b82f6; color: #3b82f6; }
.page-btn.active { background: #3b82f6; border-color: #3b82f6; color: #fff; }
.page-btn.disabled { cursor: not-allowed; opacity: 0.5; }
.pagination-btn { width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center; }
.page-size-selector { display: flex; align-items: center; gap: 5px; font-size: 13px; }
.page-size-input { width: 70px; padding: 4px 8px; }
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.modal-dialog { background: #fff; border-radius: 8px; max-height: 85vh; overflow-y: auto; }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; border-bottom: 1px solid #e7eaec; }
.modal-header h4 { margin: 0; font-size: 16px; }
.modal-close { background: none; border: none; font-size: 24px; cursor: pointer; color: #999; }
.modal-close:hover { color: #333; }
.modal-body { padding: 20px; }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px; }
.detail-item label { font-size: 11px; color: #9ca3af; display: block; margin-bottom: 2px; }
.detail-item span { font-size: 13px; color: #374151; }
.approval-history { border-top: 1px solid #e8ecf1; padding-top: 16px; margin-bottom: 20px; }
.approval-history h5 { font-size: 13px; color: #374151; margin-bottom: 12px; }
.approval-step { display: flex; align-items: center; gap: 12px; padding: 8px 0; border-bottom: 1px solid #f3f4f6; }
.step-icon { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; }
.step-icon.submitted { background: #e5e7eb; color: #6b7280; }
.step-icon.approved { background: #dcfce7; color: #16a34a; }
.step-icon.rejected { background: #fee2e2; color: #dc2626; }
.step-icon.pending { background: #fef3c7; color: #d97706; }
.step-info { flex: 1; }
.step-name { display: block; font-size: 13px; color: #374151; }
.step-time { font-size: 11px; color: #9ca3af; }
.step-comment { font-size: 12px; color: #6b7280; }
.approval-actions { border-top: 1px solid #e8ecf1; padding-top: 16px; }
.approval-actions h5 { font-size: 13px; color: #374151; margin-bottom: 12px; }
.action-btns { display: flex; gap: 10px; margin-top: 12px; }
.form-group label { display: block; font-size: 13px; color: #676a6c; margin-bottom: 5px; font-weight: 500; }
.form-group .form-control { width: 100%; padding: 8px 12px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; box-sizing: border-box; resize: vertical; }
.btn { padding: 6px 14px; border: 1px solid transparent; border-radius: 4px; font-size: 13px; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; transition: all 0.2s; }
.btn-primary { background: #3b82f6; color: #fff; border-color: #3b82f6; }
.btn-primary:hover { background: #2563eb; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }
.btn-success { background: #27ae60; color: #fff; border-color: #27ae60; }
.btn-success:hover { background: #219a52; }
.btn-danger { background: #e74c3c; color: #fff; border-color: #e74c3c; }
.btn-danger:hover { background: #c0392b; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
</style>
